import CustomWebView from '@/components/CustomWebView';
import Constants from '@/Constants';
import { ApplicationState } from '@/store';
import { acceptTermsRequest } from '@/store/identity/action';
import { LocaleData } from '@/translations/LocaleData';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import './style.scss';
import './terms-style.scss';

interface Props {
    handleModalClose?: () => void;
}

const TermsOfUse: React.FC<Props> = ({ handleModalClose }: Props) => {
    const dispatch = useDispatch();

    const [buttonVisible, setButtonVisible] = useState(false);
    const [buttonDisabled, setButtonDisabled] = useState(true);
    const [termsUrl, setTermsUrl] = useState<string>();

    const strings: LocaleData = useSelector((state: ApplicationState) => state.locale.data);
    const url: string = useSelector((state: ApplicationState) => state.appOrganization.data.url);
    const isTotvs: boolean = useSelector((state: ApplicationState) => state.appOrganization.data.isTotvs);
    const personId: number = useSelector((state: ApplicationState) => state.identity.data.person.id || 0);
    const termsAccepted: boolean = useSelector((state: ApplicationState) => !!state.identity.data.person.termsAccepted);

    const loadUrl = (): void => {
        const eulaPath = isTotvs ? 'eula/totvs/' : 'eula/';
        const file = strings._LANGUAGE === Constants.language.PT ? 'pt_br' : 'en_us';
        setTermsUrl(`${url}${eulaPath}${file}.html`);
    };

    const closeModal = (): void => {
        if (termsAccepted && handleModalClose) {
            handleModalClose();
        }
    };

    const acceptTermsOfUse = () => {
        setButtonDisabled(true);
        dispatch(acceptTermsRequest(personId));
    };

    useEffect(loadUrl, [strings._LANGUAGE]);

    useEffect(closeModal, [termsAccepted]);

    return (
        <div className="terms-of-use">
            {termsUrl && (
                <CustomWebView
                    maxHeight={450}
                    onLoad={() => setButtonVisible(true)}
                    onScrollEnd={() => setButtonDisabled(false)}
                    percentualToEnd={99}
                    uri={termsUrl}
                />
            )}

            {buttonVisible && (
                <button className={`btn btn-primary btn-block terms-button`} disabled={buttonDisabled} onClick={acceptTermsOfUse} type="button">
                    <span>{strings.ACCEPT_TERMS}</span>
                </button>
            )}
        </div>
    );
};

export default TermsOfUse;
